function applyIubendaClasses() {
  const iubendaId = window.siteConfig?.iubenda;

  const privacyElements = document.querySelectorAll(
    '.fui-field[data-field-handle="privacyPolicy"]',
  );

  privacyElements.forEach((el) => {
    if (el.dataset.iubendaApplied) return;
    el.dataset.iubendaApplied = "1";

    const link = el.querySelector("a");
    if (link) {
      if (iubendaId && link.href.includes("iubenda.com")) {
        link.href = link.href.replace(
          /iubenda\.com\/[^/]+/,
          `iubenda.com/privacy-policy/${iubendaId}`,
        );
      }

      link.classList.add(
        "iubenda-noiframe",
        "iubenda-embed",
        "iubenda-nostyle",
      );
      link.style.textDecoration = "underline";
    }
  });

  // Re-trigger iubenda to pick up dynamically added links
  if (
    window._iub &&
    window._iub.cs &&
    window._iub.cs.api &&
    window._iub.cs.api.activateEmbed
  ) {
    window._iub.cs.api.activateEmbed();
  }
}

// Run on DOMContentLoaded and formieRender
document.addEventListener("DOMContentLoaded", applyIubendaClasses);
document.addEventListener("formieRender", applyIubendaClasses);

// Watch for dynamically added forms (Sprig, AJAX, Formie late render)
new MutationObserver(() => applyIubendaClasses()).observe(document.body, {
  childList: true,
  subtree: true,
});
